import type { NextPage, NextPageContext } from 'next';

import Error from 'next/error';

interface CustomErrorComponentProps {
  statusCode: number;
  hasGetInitialPropsRun?: boolean;
  err?: Error;
}

const CustomErrorComponent: NextPage<CustomErrorComponentProps> = ({
  statusCode,
}) => {
  return <Error statusCode={statusCode} />;
};

CustomErrorComponent.getInitialProps = async (contextData: NextPageContext) => {
  return Error.getInitialProps(contextData);
};

export default CustomErrorComponent;
